import css from 'styled-jsx/css';

import { medium, largeUp } from 'constants/mediaQueries';
import Theme from 'styles/theme';

export default css`
  .typography--tertiary-heading {
    font-weight: ${Theme.get('font-weight-bold')};
    font-size: 18px;
    line-height: 1.33;
    letter-spacing: 0.5px;
    margin: 0;
    padding: 0;
  }

  @media ${medium} {
    .typography--tertiary-heading {
      font-size: 22px;
      line-height: 1.32;
    }
  }

  @media ${largeUp} {
    .typography--tertiary-heading {
      font-size: 22px;
      line-height: 1.32;
    }
  }
`;
